import * as React from 'react'
import cn from 'classnames'
import styles from './videoPopup.module.scss'
import Popup from '../popup'
import Spinner from '../spinner'

const VideoPopup = ({
  close,
  video,
  wide,
}: {
  close: () => void
  video: { src: string; title: string }
  wide?: boolean
}) => (
  <Popup closeIcon onClose={() => close()}>
    <div className={cn(styles.videoWrapper, wide && styles.videoWrapperWide)}>
      <React.Suspense fallback={<Spinner />}>
        <iframe
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          src={video.src}
          title={video.title}
        />
      </React.Suspense>
    </div>
  </Popup>
)

export default VideoPopup
